/* Store trading hours — single source of truth for "are we open right now?".
   Batch item 7, 2026-08-11.

   Owner rule: orders are blocked from 01:45 to 09:00 STORE time, for every delivery tier
   (not just Local). Blocking all tiers also keeps any sale outside California's prohibited
   2:00-6:00 AM alcohol window, so the rule is both the owner's and the law's.

   Store hours are Mon-Sun 9am-2am (sections/store-info.liquid), so 01:45 is a 15-minute
   buffer before close — enough to get a local driver out the door before 2am.

   Evaluated in America/Los_Angeles, NEVER the shopper's timezone: a customer in New York
   at 4am ET is shopping at 1am PT and the store is still open. Getting this wrong would
   block real orders and allow blocked ones. */
(function () {
  var TZ = 'America/Los_Angeles';
  var CLOSE_MIN = 1 * 60 + 45; /* 01:45 */
  var OPEN_MIN = 9 * 60;       /* 09:00 */

  function storeMinutes(now) {
    var d = now || new Date();
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, hour12: false, hour: '2-digit', minute: '2-digit'
      }).formatToParts(d);
    } catch (e) {
      return null; /* zone unresolvable — caller must fail OPEN, never block a real sale */
    }
    var hh = 0, mm = 0;
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'hour') hh = parseInt(parts[i].value, 10) % 24;
      if (parts[i].type === 'minute') mm = parseInt(parts[i].value, 10);
    }
    return hh * 60 + mm;
  }

  window.JW_STORE_HOURS = {
    timezone: TZ,
    closeCutoff: '01:45',
    openHour: '09:00',
    closedMessage: 'The store is closed. We reopen at 9:00 AM.',
    closedDetail: 'Your cart is saved — you can finish checking out from 9:00 AM.',

    /* Fails OPEN on any uncertainty. A false "closed" costs a real order; a false "open"
       is caught downstream by staff, so the asymmetry points this way on purpose. */
    isClosed: function (now) {
      var m = storeMinutes(now);
      if (m === null) return false;
      return m >= CLOSE_MIN && m < OPEN_MIN;
    },

    /* Milliseconds until the next state change, so the page can re-check exactly on the
       boundary instead of polling aggressively. Clamped so a clock jump cannot busy-loop. */
    msUntilChange: function (now) {
      var m = storeMinutes(now);
      if (m === null) return 15 * 60 * 1000;
      var target = (m >= CLOSE_MIN && m < OPEN_MIN) ? OPEN_MIN : CLOSE_MIN;
      var delta = target - m;
      if (delta <= 0) delta += 24 * 60;
      return Math.max(30 * 1000, Math.min(delta * 60 * 1000, 60 * 60 * 1000));
    }
  };
})();
